import { Alert, Box, Modal } from '@mui/material';
import React from 'react';

interface IProps {
  open: boolean;
  onClose: () => void;
  logMessages: string;
  errorMessages: string;
  closeLogMessage:(type: string) => void;
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '800px',
  height: '600px',
  maxHeight: '900px',
  overflow: 'hidden',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

const ShowLogMessage = ({ open, onClose, logMessages, errorMessages, closeLogMessage }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          {!errorMessages && !logMessages && <span>No logs found...</span>}
          {errorMessages && (
            <Box sx={{ marginTop: '10px' }}>
              <span>Error Messages: </span>
              <Alert severity="error" sx={{ whiteSpace: 'pre-line' }}>
                {errorMessages}
              </Alert>
            </Box>
          )}
          {logMessages && (
            <Box sx={{ marginTop: '10px' }}>
              <span>Log Messages: </span>
              <Alert severity="info" sx={{ whiteSpace: 'pre-line' }}>
                {logMessages}
              </Alert>
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default ShowLogMessage;
